import axios from "axios";

export const api = axios.create({
  baseURL: document.querySelector("#basePath").value,
  timeout: 50000,
  // headers: {
  //   //'X-Auth-Token': 'f2b6637ddf355a476918940289c0be016a4fe99e3b69c83d',
  //   // "Content-Type": "application/json"
  // },
  json: true
});

export const apiHttps = axios.create({
  baseURL: document.querySelector("#basePath").value,
  timeout: 50000,
  // headers: {
  //   //'X-Auth-Token': 'f2b6637ddf355a476918940289c0be016a4fe99e3b69c83d',
  //   // "Content-Type": "application/json"
  // },
  json: true
});
